import { render } from "./SalePage.vue?vue&type=template&id=001b25f4&scoped=true"
import script from "./SalePage.vue?vue&type=script&lang=js"
export * from "./SalePage.vue?vue&type=script&lang=js"

import "./SalePage.vue?vue&type=style&index=0&id=001b25f4&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001b25f4"]])

export default __exports__